/* eslint-disable @typescript-eslint/no-empty-function */
// Mock implementation of Datadog for web
export const DdLogs = {
  init: () => {},
  // Add other methods that are used in your code
};

export const DdRum = {
  init: () => {},
  addAction: () => Promise.resolve(),
  // Add other methods that are used in your code
};

export const DdSdkReactNative = {
  initialize: () => {},
  // Add other methods that are used in your code
};

export enum ErrorSource {}
// Add your enum values here

// Mirror of @datadog/mobile-react-native's RumActionType enum. utils/analytics.ts
// and utils/adyenAnalytics.ts import this as a value (RumActionType.CUSTOM /
// RumActionType[key]), so the web mock must export it or the Vite build fails to
// resolve the named import.
export enum RumActionType {
  TAP = 'TAP',
  SCROLL = 'SCROLL',
  SWIPE = 'SWIPE',
  BACK = 'BACK',
  CUSTOM = 'CUSTOM',
}
